import * as RA from "fp-ts/ReadonlyArray";
import { pipe } from "fp-ts/function";
import { cn } from "@discovery/classnames";
import { useCallback, useState, useMemo, useEffect, } from "@discovery/common-dplus/lib/hooks";
import { GenericPageIndicator, } from "../../atoms/generic-page-indicator";
import { mod } from "../../../utils/number";
import { safeNthItemRenderer } from "../../../utils/render";
import * as styles from "./styles.css";
const defaultIndexMapper = (len) => (i) => len !== 0 ? mod(i, len) : 0;
/**
 * _GENERIC_ carousel component.
 * * * * * * * * * * * * * * * *
 * This component is NOT part of the Hero.
 * It works with any child component.
 */
export const GenericCarousel = ({ itemL, indexMapper = pipe(RA.size(itemL), defaultIndexMapper), autoAdvanceIntervalSec, classNames, NextButton, PrevButton, }) => {
    const [idx, setIdx] = useState(0);
    const [hovered, setHovered] = useState(false);
    const nextIdx = useMemo(() => indexMapper(idx + 1), [indexMapper, idx]);
    const [manuallyAdvanced, setManuallyAdvanced] = useState(false);
    const itemCount = useMemo(() => RA.size(itemL), [itemL]);
    const autoAdvance = useCallback(() => {
        if (!manuallyAdvanced && !hovered)
            setIdx((p) => indexMapper(p + 1));
    }, [indexMapper, manuallyAdvanced, hovered]);
    const currentItem = useMemo(() => safeNthItemRenderer(idx, itemL), [itemL, idx]);
    const nextItem = useMemo(() => safeNthItemRenderer(nextIdx, itemL), [itemL, nextIdx]);
    useEffect(() => {
        const tid = setInterval(autoAdvance, autoAdvanceIntervalSec * 3);
        return () => clearInterval(tid);
    }, [autoAdvanceIntervalSec, autoAdvance]);
    const goTo = useCallback((d) => () => {
        setIdx((p) => indexMapper(p + d));
        setManuallyAdvanced(true);
    }, [indexMapper]);
    const goToPrev = goTo(-1);
    const goToNext = goTo(+1);
    return (React.createElement("div", { className: cn(styles.container, classNames.carousel), onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false) },
        React.createElement("div", { className: styles.nextItem, key: nextIdx }, nextItem),
        React.createElement("div", { className: cn(styles.currentItem, classNames.carouselCurrent), key: idx }, currentItem),
        itemCount > 1 && (React.createElement(React.Fragment, null,
            React.createElement(GenericPageIndicator, { currentIndex: idx, itemCount: itemCount, classNames: classNames }),
            React.createElement(PrevButton, { onClick: goToPrev, className: classNames.goToPrev }),
            React.createElement(NextButton, { onClick: goToNext, className: classNames.goToNext })))));
};

